import CardAboutModal from "./CardAboutModal";
import PlayBox from "./PlayBox";
import ThisIsModal from "./ThisIsModal";
import Thumbnail from "./Thumbnails";
import { useAppDispatch } from "@/hooks";
import {
  Box,
  Card,
  CardBody,
  Center,
  Divider,
  HStack,
  Stack,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { useInView } from "framer-motion";
import Link from "next/link";
import { CSSProperties, useRef } from "react";

export default function ExampleCard() {
  const { colorMode } = useColorMode();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const dispatch = useAppDispatch();

  const backgroundColor = colorMode === "light" ? "light.100" : "black";

  const example = {
    id: 148,
    scid: "SC_YOUSAY075956DF",
    title: "You Say To Me feat. Elena K (Standard Edition)",
    link: "",
    cards: [
      {
        id: 97,
        collector: {
          id: 80,
          name: "Phillip",
        },
      },
      {
        id: 117,
        collector: {
          id: 76,
          name: "Aaron",
        },
      },
    ],
    image: "https://dfkbrdbkwd97.cloudfront.net/YSTMOPTIMISED.gif",
    comp_file: "https://dfkbrdbkwd97.cloudfront.net/YSTMOPTIMISED.gif",
    song: {
      id: 186,
      title: "You Say To Me (feat. Elena K)",
      file: "https://dfkbrdbkwd97.cloudfront.net/Raven_feat._Elena_K_-_You_Say_To_Me.mp3",
      ext_file:
        "https://dfkbrdbkwd97.cloudfront.net/Raven_feat._Elena_K_-_You_Say_To_Me.mp3",
      wav_file: "",
    },
    includes: "Original Version of You Say To Me, Original Coverart",
    inc_list: [""],
    inc_songs: null,
    inc_media:
      "https://drive.google.com/drive/folders/13THn5k-k_Lh08KvwwIRV_RUIDuFU2Ogn?usp=drive_link",
    quantity: 66,
    tx_id: null,
    thumbnail: "https://dfkbrdbkwd97.cloudfront.net/YSTMCOLLECTORSCOMPED.gif",
    thumbnailmd:
      "https://dfkbrdbkwd97.cloudfront.net/cache/ab/cc/abcc3b898204b1ddb81fb522e48e403f.jpg",
    thumbnailsm:
      "https://dfkbrdbkwd97.cloudfront.net/cache/1a/0c/1a0c5ba3e1bf0416a7272d38d080218b.jpg",
    desc: "This was the very first song I made as Raven.\r\n\r\nIn the beginning it was more a way to help me deal with the break-up of my ex-girlfriend who left me heartbroken up to this very day.\r\nAfter feeling that I love rapping and professional music production, It quickly became a serious business. So this song was the start of a very important part of my life. \r\n\r\nThis Songcard is also available as Collectors Edition with extended content.",
    sol_token: "6kSBeY1yCBDP8gRsqDArss7Kf1E1LnGLuvu587YxhgFw",
    is_paid: true,
    price: 2.0,
    sold_out: false,
    uuid: "075956df-e32d-406e-98b1-467269f58f08",
    issued: "2023-10-11T17:24:17.556171Z",
    collector: [
      {
        id: 1,
        name: "Christopher",
      },
      {
        id: 83,
        name: "Raven",
      },
      {
        id: 80,
        name: "Phillip",
      },
      {
        id: 76,
        name: "Aaron",
      },
    ],
    contract_address: null,
    tokens: [],
    primary_artist: {
      id: 20,
      name: "Raven",
      slug: "raven",
      instagram: "ravenmus1c",
    },
    artist: [
      {
        id: 20,
        name: "Raven",
        slug: "raven",
        instagram: "ravenmus1c",
      },
    ],
    g_folder_id: "13THn5k-k_Lh08KvwwIRV_RUIDuFU2Ogn",
    holds: [],
    game: null,
    ext_file: "",
    hold_count: 2,
    available: 64,
    preview_length: null,
  };

  return (
    <div>
      <Center
        ref={ref}
        style={{
          transform: isInView ? "none" : "translateY(+100px)",
          // opacity: isInView ? 1 : 0.2,
          transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
        }}
      >
        <Card
          maxW="xs"
          align="center"
          bgColor={colorMode == "dark" ? "black" : "white"}
          variant="outline"
          borderColor={colorMode == "dark" ? "white" : "black"}
          borderStyle="dotted"
          borderRadius={15}
          shadow={"md"}
        >
          <CardBody>
            <Link href={`cards/${example.uuid}`}>
              <Center>
                <Box height={285} width={285}>
                  <Thumbnail
                    // url={example.image}
                    // thumbnail={""}
                    ext_file={""}
                    comp_file={example.image}
                  />
                </Box>
              </Center>
            </Link>
            <Stack mt="4" mb="0" spacing="3">
              <Center>
                <PlayBox card={example} collection={false} />
              </Center>

              <Text ml={4} mb={0} mt={2}>
                is a Songcard from
                <br />
                {example.primary_artist && (
                  <Text as="b" key={example.primary_artist.slug}>
                    <Link href={`/artists/${example.primary_artist.slug}`}>
                      {example.primary_artist.name}
                    </Link>
                  </Text>
                )}
              </Text>
              <Divider mb={0} />
              <Center>
                <HStack justify="space-between" w="94%">
                  <CardAboutModal
                    card={example}
                    price={false}
                    showOpen={true}
                  />
                  <ThisIsModal card={example} price={false} showOpen={false} />
                </HStack>
              </Center>
            </Stack>
          </CardBody>
        </Card>
      </Center>
    </div>
  );
}

const containerStyle: CSSProperties = {
  whiteSpace: "pre-line",
};

// const containerStyle = {
//   whiteSpace: "pre-line",
// };
